import * as React from 'react';
import * as styles from './ActionButtonsContainer.css';

export const ActionButtonsContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['action-buttons']}>{children}</div>;
};
